export default [
  { id: '1', name: 'Reefer 1' },
  { id: '2', name: 'Reefer 2' },
]
